import React from "react";
import { useAppDispatch, useAppSelector } from "stores/hooks";
import { markSearchFlow, selectUI } from "stores/ui/uiSlice";
interface MobileAccordianCommonProps {
  currentTab: "location" | "dates" | "guest" | null;
  title: string;
  children: React.ReactNode;
  className: string;
  additionalSummaryContent?: React.ReactNode;
}
const MobileAccordianCommon: React.FC<MobileAccordianCommonProps> = ({
  currentTab = "location",
  title,
  children,
  className,
  additionalSummaryContent
}) => {
  const dispatch = useAppDispatch();
  const {
    currentSearchTab
  } = useAppSelector(selectUI);
  const isOpen = currentSearchTab === currentTab;
  const onToggleClick = () => {
    if (!isOpen) {
      dispatch(markSearchFlow({
        currentSearchTab: currentTab
      }));
    }
  };
  return <div className='group mb-4 rounded-lg bg-white shadow-[0_4px_20px_0_rgba(55,56,77,0.13)]' data-sentry-component="MobileAccordianCommon" data-sentry-source-file="MobileAccordianCommon.tsx">
      {/* Accordion summary displaying the title and summary of the accordion  */}
      <div role='button' tabIndex={0} onClick={onToggleClick} onKeyDown={e => {
      if (e.key === "Enter" || e.key === " ") onToggleClick();
    }} className={`flex w-full items-center justify-between px-4 py-[18px] ${isOpen ? "pointer-events-none" : "cursor-pointer"}`}>
        {isOpen ? <p className='text-base font-semibold leading-4 tracking-[-0.16px] text-brand-dark'>
            {title}
          </p> : <p className='text-sm font-semibold leading-[14px] tracking-[-0.14px] text-Gray-600'>
            {title}
          </p>}
        {!isOpen && additionalSummaryContent}
      </div>
      {/* Content of the accordion, shown when the accordion is open */}
      <div className={`overflow-hidden pt-[1px] transition-[max-height] duration-500 ease-out ${isOpen ? className : "max-h-px"}`}>
        {children}
      </div>
    </div>;
};
export default MobileAccordianCommon;